import { Body, Flex } from '@cognite/cogs-core';

import * as S from './elements';

interface Props {
  loadingText: string;
}

export const LoadingSchedulesPlaceholder = ({ loadingText }: Props) => {
  return (
    <Flex
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap={20}
      fullHeight
      data-testid="loading-schedules-placeholder"
    >
      <S.StyledLoaderIcon />
      <Body size="medium">{loadingText}</Body>
    </Flex>
  );
};
